export const theme = 'black';
export const whiteList = ['nl'];
export const url = 'ecoflow-stream-plug-in-thuisbatterij';
export const generalKeys = ['product_spu_bk626', 'product_bk623', 'product_bk625'];
